import { ActionReducerMap } from '@ngrx/store';
import { authReducer, AuthState } from '../auth/auth.reducer';
import { searchReducer, SearchState } from '../search/search.reducer';
import { reportReducer, ReportState } from '../report/report.reducer';
import { accountReducer, AccountState } from '../account/account.reducer';
import { gdprNoticeReducer, GdprNoticeState } from '../gdprNotice/gdprNotice.reducer';
import { billingReducer, BillingState } from '../billing/billing.reducer';
import { subscriptionReducer, SubscriptionState } from '../subscription/subscription.reducer';
import { userProfileReducer, UserProfileState } from '../userProfile/userProfile.reducer';
import { oauthReducer, OAuthState } from "../oauth/oauth.reducer";
import { listReducer, ListState } from "../list/list.reducer";
import { billingProfileReducer, BillingProfileState } from "../billingProfile/billingProfile.reducer";
import { serpApiReducer, SerpApiState } from "../serpApi/serpApi.reducer";
import { profileListReducer, ProfileListState } from "../profileList/profileList.reducer";
import { tagReducer, TagState } from "../tag/tag.reducer";
import { psyTestingReducer, PsyTestingState } from "../psyTesting/psyTesting.reducer";
import { dashboardReducer, DashboardState } from "../dashboard/dashboard.reducer";
import { UiState } from "../ui/ui.state";
import { uiReducer } from "../ui/ui.reducer";
import { advancedSearchReducer, AdvancedSearchState } from "../advancedSearch/advanced-search.reducer";
import { googleReducer, GoogleState } from '../google/google.reducer';
import { hubspotReducer, HubspotState } from '../hubspot/hubspot.reducer';
import { livespaceReducer, LivespaceState } from '../livespace/livespace.reducer';
import { tourReducer, TourState } from '../tour/tour.reducer';
import { workspaceReducer, WorkspaceState } from '../workspace/workspace.reducer';
import { crmReducer, CrmState } from '../crm/crm.reducer';
import { marketingReducer, MarketingState } from '../marketing/marketing.reducer';
import { icpReducer, IcpState } from '../icp/icp.reducer';
import { onboardingReducer, OnboardingState } from '../onboarding/onboarding.reducer';
import { veridionExportReducer, VeridionExportState } from '../veridionExport/veridion-export.reducer';
import { searchExportReducer, SearchExportState } from '../searchExport/search-export.reducer';
import { dailyLeadLegacyReducer, DailyLeadLegacyState } from '../dailyLeadLegacy/daily-lead.reducer';
import { leadPipelineReducer, LeadPipelineState } from '../leadPipeline/lead-pipeline.reducer';

// Define the global state interface
export interface AppState {
  auth: AuthState;
  search: SearchState;
  report: ReportState;
  account: AccountState;
  gdprNotice: GdprNoticeState;
  billing: BillingState;
  subscription: SubscriptionState;
  userProfile: UserProfileState;
  oauth: OAuthState;
  list: ListState;
  billingProfile: BillingProfileState;
  serpApi: SerpApiState;
  profileList: ProfileListState;
  tag: TagState;
  psyTesting: PsyTestingState;
  dashboard: DashboardState;
  ui: UiState;
  advancedSearch: AdvancedSearchState;
  google: GoogleState;
  hubspot: HubspotState;
  livespace: LivespaceState;
  tour: TourState;
  workspace: WorkspaceState;
  crm: CrmState;
  marketing: MarketingState;
  icp: IcpState;
  onboarding: OnboardingState;
  veridionExport: VeridionExportState;
  searchExport: SearchExportState;
  dailyLeadLegacy: DailyLeadLegacyState;
  leadPipeline: LeadPipelineState;
  // other states...
}

// Aggregate all reducers for the application
export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  search: searchReducer,
  report: reportReducer,
  account: accountReducer,
  gdprNotice: gdprNoticeReducer,
  billing: billingReducer,
  subscription: subscriptionReducer,
  userProfile: userProfileReducer,
  oauth: oauthReducer,
  list: listReducer,
  billingProfile: billingProfileReducer,
  serpApi: serpApiReducer,
  profileList: profileListReducer,
  tag: tagReducer,
  psyTesting: psyTestingReducer,
  dashboard: dashboardReducer,
  ui: uiReducer,
  advancedSearch: advancedSearchReducer,
  google: googleReducer,
  hubspot: hubspotReducer,
  livespace: livespaceReducer,
  tour: tourReducer,
  workspace: workspaceReducer,
  crm: crmReducer,
  marketing: marketingReducer,
  icp: icpReducer,
  onboarding: onboardingReducer,
  veridionExport: veridionExportReducer,
  searchExport: searchExportReducer,
  dailyLeadLegacy: dailyLeadLegacyReducer,
  leadPipeline: leadPipelineReducer,
  // other reducers...
};

